import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
// import { handleRipple } from '../../../../helpers/ripple';
import {
  IconButton,
  LockScroll,
  NavbarSection,
  NavbarList,
  NavbarLink,
  LoginButton,
} from './styled';

interface NavbarItem {
  key: string;
  text: string;
  link: string;
  openNewTab: boolean;
}

interface ButtonData {
  buttonText: string;
  buttonLink: string;
}

interface MenuProps {
  isOpen: boolean;
  onClick: () => void;
  navbarList: NavbarItem[];
  buttonData: ButtonData;
}

const Menu: React.FC<MenuProps> = ({
  isOpen,
  onClick,
  navbarList,
  buttonData,
}) => {
  const handleButtonClick = (): void => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <>
      <IconButton onClick={handleButtonClick}>
        {isOpen ? (
          <IoMdClose size={40} color="#1c1c1c" />
        ) : (
          <GiHamburgerMenu size={40} color="#1c1c1c" />
        )}
      </IconButton>
      <LockScroll locked={isOpen} />
      <NavbarSection open={isOpen}>
        <NavbarList>
          {navbarList.map((item: NavbarItem) => (
            <NavbarLink
              key={item.key}
              href={item.link}
              target={item.openNewTab ? '_blank' : undefined}
            >
              {item.text}
            </NavbarLink>
          ))}
        </NavbarList>
        <LoginButton
          href={buttonData.buttonLink}
          target="_blank"
          // onMouseEnter={handleRipple}
        >
          {buttonData.buttonText}
        </LoginButton>
      </NavbarSection>
    </>
  );
};

export default Menu;
